export function useCache() {
  const storage =
    typeof localStorage !== "undefined"
      ? localStorage
      : {
          getItem: () => null,
          setItem: () => null,
          removeItem: () => null,
          clear: () => null,
        };

  const storeItem = (key: string, value: string) => {
    storage.setItem(key, value);
  };

  const getItem = (key: string) => {
    return storage.getItem(key) || "";
  };

  const getEstablishmentSlug = () => {
    return getItem("establishment_slug");
  };

  const getIsOwner = () => {
    return getItem("is_owner") === "true";
  };

  const clearCache = () => {
    storage.clear();
  };

  return {
    storeItem,
    getItem,
    getEstablishmentSlug,
    getIsOwner,
    clearCache,
  };
}
